/* global swal angular _*/
import './style.less';
import { isEqual, uniq, map, keyBy } from 'lodash';
import addActivityTemplate from 'modals/addActivity/template.html';
import addActivityController from 'modals/addActivity/index';
import addCoursesTemplate from 'modals/addCourses/template.html';
import addCoursesController from 'modals/addCourses/index';
import addExternalEventsTemplate from 'modals/addExternalEvents/template.html';
import addExternalEventsController from 'modals/addExternalEvents/index';
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';
import moment from 'moment-timezone';

export default function($q, $location, $stateParams, $uibModal, $log, ApiClass, HelperClass, Swal) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  vm.activeTab = $stateParams.tab || 'info';

  vm.sortableOptions = {
    connectWith: '.connectList'
  };

  vm.onFilter = function(stCtrl) {
    const newFiltered = stCtrl.getFilteredCollection().map(({ email }) => email);

    if (!isEqual(vm.filtered.map(({ email }) => email), newFiltered)) {
      vm.select = false;
    }

    vm.filtered = stCtrl.getFilteredCollection();
  };

  vm.uploadedProductImage = link => {
    vm.ngModel.productImageUrl = link;
  };

  vm.selectEmployees = () => {
    const filterEmployees = vm.users.map(({ email }) => email);
    const dateString = moment()
      .add(1, 'week')
      .hour(8)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('MM/DD/YYYY');

    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        size: 'lg',
        template: employeeModalTemplate,
        controller: EmployeeModalController(
          filterEmployees,
          undefined,
          undefined,
          true,
          ['due_date'],
          [['john@prolaera.com', dateString], ['jane@prolaera.com', dateString]]
        ),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(users => {
        const timezone = moment.tz.guess();

        return ApiClass.learningsIdTypePut(
          { id: $stateParams.track_id, type: 'assigned' },
          {
            assignedTrackParams: users.map(({ csvSelect = {}, profile_uid }) => {
              const { due_date } = csvSelect;

              return {
                due_date: due_date
                  ? moment(due_date, 'MM/DD/YYYY', timezone)
                      .hour(8)
                      .minute(0)
                      .second(0)
                      .millisecond(0)
                      .toISOString()
                  : undefined,
                profile_uid
              };
            })
          },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        swal('Success', 'The selected employees have been added to this learning track', 'info');
        activate();
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.remove = profile_uid => {
    ApiClass.learningsIdTypeTypeIdDelete(
      { id: $stateParams.track_id, type: 'assigned', type_id: profile_uid },
      {},
      { queryParams: { manage: true } }
    )
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  const validator = value => {
    if (!value) return 'Please enter date';
    if (!HelperClass.validateDate(value)) return 'Date is not valid';
    return;
  };

  vm.setDueDate = user => {
    vm.laddaBtnDudeDate = true;

    Swal.input('Due Date', '', 'MM/DD/YYY', 'text', validator)
      .then(response => {
        const { value, dismiss } = response;
        if (dismiss || !value) {
          vm.laddaBtnDudeDate = false;
          return;
        }

        const due_date = HelperClass.cleanDate(value);

        const users = user ? [user] : vm.selectedUsers;

        const qArr = users.map(({ profile_uid, track_id }) =>
          ApiClass.learningsIdTypeTypeIdPatch(
            { id: $stateParams.track_id, type: 'assigned', type_id: profile_uid },
            { profile_uid, track_id, due_date },
            { queryParams: { manage: true } }
          )
        );

        return $q.all(qArr).then(() => {
          vm.laddaBtnDudeDate = false;
          activate();
        });
      })
      .catch(error => {
        vm.laddaBtnDudeDate = false;
        $log.error(error);
        throw error;
      });
  };

  vm.removeSelected = () => {
    vm.laddaBtnRemove = true;
    const qArr = vm.selectedUsers.map(({ profile_uid }) =>
      ApiClass.learningsIdTypeTypeIdDelete(
        { id: $stateParams.track_id, type: 'assigned', type_id: profile_uid },
        {},
        { queryParams: { manage: true } }
      )
    );

    $q.all(qArr)
      .then(() => {
        vm.laddaBtnRemove = false;
        activate();
      })
      .catch(error => {
        vm.laddaBtnRemove = false;
        $log.error(error);
        throw error;
      });
  };

  vm.updateSearch = tab => $location.search('tab', tab);

  vm.addActivityModal = function() {
    const activities = angular.copy(vm.activities);
    $uibModal
      .open({
        template: addActivityTemplate,
        backdrop: 'static',
        size: 'lg',
        windowClass: 'modal',
        controller: addActivityController(activities)
      })
      .result.then(activities => {
        const type = 'activity';
        const newContent = activities.map(activity => ({ type, activity_id: activity.uuid, activity }));
        vm.formData.content.push(...newContent);
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.addCourseModal = function(type) {
    $uibModal
      .open({
        template: addCoursesTemplate,
        backdrop: 'static',
        size: 'lg',
        windowClass: 'modal',
        controller: addCoursesController(type)
      })
      .result.then(courses => {
        type = type === 'selfStudy' ? 'course' : 'event';
        const newContent = courses.map(course => ({ type, course_id: course.course_id, course }));
        vm.formData.content.push(...newContent);
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.addExternalEventsModal = function() {
    const externalEvents = angular.copy(vm.externalEvents);
    $uibModal
      .open({
        template: addExternalEventsTemplate,
        backdrop: 'static',
        size: 'lg',
        windowClass: 'modal',
        controller: addExternalEventsController(externalEvents)
      })
      .result.then(externalEvents => {
        const type = 'externalEvent';
        const newContent = externalEvents.map(externalEvent => ({
          type,
          course_id: externalEvent.course_id,
          externalEvent,
          event_id: externalEvent.event_id
        }));
        vm.formData.content.push(...newContent);
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.selectFiltered = () => filterSelectedUsers();

  vm.selectAll = select => {
    vm.filtered.forEach(user => (user.selected = select));
    filterSelectedUsers();
  };

  vm.submit = function(track) {
    const {
      track_id,
      author,
      name,
      description,
      courses = [],
      updates,
      content = [],
      productImageUrl,
      sendEmail,
      tags
    } = angular.copy(track);
    if (!name) return swal('Hold Up!', 'Please add a name for the learning track.', 'info');
    if (!author) return swal('Hold Up!', 'Please add a author for the learning track.', 'info');
    if (!description) return swal('Hold Up!', 'Please add a description for the learning track.', 'info');

    vm.btnSubmit = true;
    return ApiClass.learningsIdPatch(
      { id: track_id },
      { track_id, name, author, description, content, courses, productImageUrl, sendEmail, tags, updates },
      { queryParams: { manage: true } }
    )
      .then(() => (vm.btnSubmit = false))
      .catch(error => {
        $log.error(error);
        vm.btnSubmit = false;
        if (error === 'cancel') return;
        throw error;
      });
  };

  function filterSelectedUsers() {
    vm.selectedUsers = angular.copy(vm.users).filter(({ selected }) => selected);
  }

  function activate() {
    $log.debug('Admin Learning Controller Activated');

    vm.loaded = false;
    vm.error = {};

    vm.profile_uid = $stateParams.id;
    vm.selectedUsers = [];

    ApiClass.learningsIdGet(
      { id: $stateParams.track_id },
      {},
      {
        queryParams: {
          manage: true,
          joins: JSON.stringify({ content: true, assigned: true })
        }
      }
    )
      .then(({ data: { track } }) => {
        if (track.progress) {
          track.progress.forEach(progress => {
            progress.archived = !!progress.archived;

            const { completed, content_count } = progress.progress;

            progress.status = completed === content_count ? 'completed' : completed === 0 ? 'none' : 'started';
          });
        }

        vm.formData = track;
        vm.users = track.progress || [];
        vm.statusGroup = uniq(map(vm.users, 'status'));
        vm.filtered = vm.users;

        if (!vm.formData.content) {
          vm.formData.content = [];
        }

        vm.coursesToAdd = [];

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/learningTracks/edit/controller.js